import { Button, QRCode, message, Row, Col } from "./../ui/ot";
import axios from "axios"
import { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { url, client_id } from './setting'
import styled from "styled-components";
import { FaLine } from 'react-icons/fa';

const BindLineId = ({
    name,
    userId,
    onSuccess = () => { }
}) => {
    const [date_now] = useState(Date.now())
    const [bind, setBind] = useState(false);
    const user_id = userId ? { user_id: userId } : {}
    // const getQrcodeBind = () => {
    //     axios
    //         .get('/qrcode/bind', {
    //             params: {
    //                 ...user_id
    //             }
    //         })
    //         .then(response => {
    //             if ((response.data?.data || []).find(_ => true)?.line_user_id) {
    //                 line_login_ref.current = false
    //                 setBind(true);
    //             } else {
    //                 setBind(false);
    //                 patch_line_bind()
    //             }
    //         })
    // }
    useEffect(() => {
        patch_line_bind(false)
        return () => {
            line_login_ref.current = false
        }
    }, [])
    const line_login_ref = useRef(true);
    const get_line_login = () => {
        axios
            .patch('/qrcode/bind',
                {
                    result_code: date_now,
                    ...user_id
                }
            )
            .then(response => {
                if (response.data?.refresh_token) {
                    onSuccess({
                        target: {
                            name,
                            value: response.data?.refresh_token
                        }
                    })
                    line_login_ref.current = false
                }
            })
    }
    const patch_line_bind = (checked) => {
        axios
            .get('/home/user_self', {
                params: {
                    ...user_id
                }
            })
            .then(response => {
                if ((response.data?.data || []).find(_ => true)?.line_user_id) {
                    line_login_ref.current = false
                    if(checked)
                        message.success('綁定完成')
                    setBind(true)
                    onSuccess({
                        target: {
                            name,
                            value: (response.data?.data || []).find(_ => true)?.line_user_id
                        }
                    })
                }
            })
            .finally(() => {
                if (line_login_ref.current) {
                    setTimeout(() => patch_line_bind(true), 1000)
                    setTimeout(() => get_line_login(), 1000)
                }
            })
    }
    const resetLineUserId = () => {
        axios
            .patch('/home/user_self', [{
                ...user_id,
                line_user_id: null
            }])
            .then(response => {
                line_login_ref.current = true
                setBind(false);
                patch_line_bind()
                onSuccess({
                    target: {
                        name,
                        value: null
                    }
                })
            })
    }
    const lineUrl = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${client_id}&redirect_uri=${url}&state=` +
        encodeURI(JSON.stringify({
            state: date_now,
            service: '/',
            ...user_id
        })) +
        '&scope=profile%20openid&nonce=' + date_now
    return (<>

        <Row gutter={[16, 8]} style={{ alignItems: 'center' }}>
            {bind && <>已完成綁定</>}
            {bind && <Button onClick={() => {
                resetLineUserId()
            }}>重新綁定</Button>}
            {!bind &&
                <>
                    <Col style={{ justifyItems: 'center' }}>
                        請掃描以下QRcode進行綁定
                        <QRCode
                            value={lineUrl}
                        />
                    </Col>
                </>
            }
            {!bind && <>
                <LineButton type={'default'} onClick={() => {
                    window.open(lineUrl)
                }}><FaLine />前往綁定</LineButton>
            </>}
        </Row >
    </>)
}
export default BindLineId

const LineButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #06c755;         /* LINE 綠 */
  color: white;
  font-weight: bold;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-size: 16px;
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #05b14c;
  }

  svg {
    margin-right: 8px;
    font-size: 20px;
  }
`;